import React, {useContext, useEffect, useState} from 'react';
import TourListItem from "../components/Tour-list-item/Tour-list-item";
import {axios} from "../axios";
import {LangContext} from "../App";
import {FormControl, MenuItem, Select} from "@mui/material";

import Seo from "../components/Seo/Seo";

const OtherToursPage = () => {
    const [type, setType] = useState('')
    const [country, setCountry] = useState('')
    const [data,setData] = useState([])
    const lang = useContext(LangContext)
    useEffect(()=>{
        axios.get(`${lang}/other-tour?type=${type}&country=${country}`)
            .then( res => setData(res.data.tours))
    },[lang,type,country])
    return (
        <div className='tours'>
            <Seo pageKey="europeTours" />
            <div className="center-wrapper flex-column">
                <div className="d-flex py-5">
                    <button
                        onClick={()=> setType('')}
                        className={`btn btn-custom ${type === '' && 'active'}`}
                    >All</button>
                    <button
                        onClick={()=> setType('private')}
                        className={`btn btn-custom ${type === 'private' && 'active'}`}
                    >Private tours</button>
                    <button
                        onClick={()=> setType('group')}
                        className={`btn btn-custom ${type === 'group' && 'active'}`}
                    >Group tours</button>
                    <p className='white-space align-content-center ms-5 me-3'>Select Country: </p>
                    <FormControl sx={{ width:'270px' }}>
                        <Select
                            value={country}
                            onChange={e => setCountry(e.target.value)}
                        >
                            <MenuItem value="albania">Albania</MenuItem>
                            <MenuItem value="andorra">Andorra</MenuItem>
                            <MenuItem value="austria">Austria</MenuItem>
                            <MenuItem value="belarus">Belarus</MenuItem>
                            <MenuItem value="belgium">Belgium</MenuItem>
                            <MenuItem value="bosnia_and_herzegovina">Bosnia and Herzegovina</MenuItem>
                            <MenuItem value="bulgaria">Bulgaria</MenuItem>
                            <MenuItem value="croatia">Croatia</MenuItem>
                            <MenuItem value="cyprus">Cyprus</MenuItem>
                            <MenuItem value="czech_republic">Czech Republic</MenuItem>
                            <MenuItem value="denmark">Denmark</MenuItem>
                            <MenuItem value="estonia">Estonia</MenuItem>
                            <MenuItem value="finland">Finland</MenuItem>
                            <MenuItem value="france">France</MenuItem>
                            <MenuItem value="germany">Germany</MenuItem>
                            <MenuItem value="georgia">Georgia</MenuItem>
                            <MenuItem value="greece">Greece</MenuItem>
                            <MenuItem value="hungary">Hungary</MenuItem>
                            <MenuItem value="iceland">Iceland</MenuItem>
                            <MenuItem value="ireland">Ireland</MenuItem>
                            <MenuItem value="italy">Italy</MenuItem>
                            <MenuItem value="kosovo">Kosovo</MenuItem>
                            <MenuItem value="latvia">Latvia</MenuItem>
                            <MenuItem value="liechtenstein">Liechtenstein</MenuItem>
                            <MenuItem value="lithuania">Lithuania</MenuItem>
                            <MenuItem value="luxembourg">Luxembourg</MenuItem>
                            <MenuItem value="malta">Malta</MenuItem>
                            <MenuItem value="moldova">Moldova</MenuItem>
                            <MenuItem value="monaco">Monaco</MenuItem>
                            <MenuItem value="montenegro">Montenegro</MenuItem>
                            <MenuItem value="netherlands">Netherlands</MenuItem>
                            <MenuItem value="north_macedonia">North Macedonia</MenuItem>
                            <MenuItem value="norway">Norway</MenuItem>
                            <MenuItem value="poland">Poland</MenuItem>
                            <MenuItem value="portugal">Portugal</MenuItem>
                            <MenuItem value="romania">Romania</MenuItem>
                            <MenuItem value="russia">Russia</MenuItem>
                            <MenuItem value="san_marino">San Marino</MenuItem>
                            <MenuItem value="serbia">Serbia</MenuItem>
                            <MenuItem value="slovakia">Slovakia</MenuItem>
                            <MenuItem value="slovenia">Slovenia</MenuItem>
                            <MenuItem value="spain">Spain</MenuItem>
                            <MenuItem value="sweden">Sweden</MenuItem>
                            <MenuItem value="switzerland">Switzerland</MenuItem>
                            <MenuItem value="ukraine">Ukraine</MenuItem>
                            <MenuItem value="united_kingdom">United Kingdom</MenuItem>
                            <MenuItem value="vatican_city">Vatican City</MenuItem>
                            <MenuItem value="israel">Israel</MenuItem>
                            <MenuItem value="canada">Canada</MenuItem>
                            <MenuItem value="usa">USA</MenuItem>
                            <MenuItem value="ame">AME</MenuItem>
                            <MenuItem value="australia">Australia</MenuItem>
                            <MenuItem value="singapore">Singapore</MenuItem>
                            <MenuItem value="malaysia">Malaysia</MenuItem>
                            <MenuItem value="monaco">Monaco</MenuItem>
                            <MenuItem value="japan">Japan</MenuItem>
                        </Select>
                    </FormControl>
                </div>
                <div className="tours-grid">
                    {data?.map(e => <TourListItem tour={e} path='other-tour'/>)}
                </div>
            </div>
        </div>
    );
};

export default OtherToursPage;